import { useQuery, QueryFunction } from 'react-query';
import { getAllSystemConfigs, getSystemConfigByKey, SystemConfig, SystemConfigQueries } from '../../services/apiSLTP/systemConfig';

type UseSystemConfigsQueryOptions = {
    queries?: SystemConfigQueries;
};

const fetchAllSystemConfigs: QueryFunction<SystemConfig[]> = async ({ queryKey }) => {
    const [, options] = queryKey as [string, UseSystemConfigsQueryOptions];
    const { queries } = options;

    const response = await getAllSystemConfigs(queries);
    return response.data;
};

export const useSystemConfigsQuery = (options?: UseSystemConfigsQueryOptions) => {
    return useQuery(['systemConfigs', options || {}], fetchAllSystemConfigs);
};

type UseSystemConfigByKeyQueryOptions = {
    key: string;
};

const fetchSystemConfigByKey: QueryFunction<SystemConfig> = async ({ queryKey }) => {
    const [, params] = queryKey as [string, UseSystemConfigByKeyQueryOptions];
    const { key } = params;

    const response = await getSystemConfigByKey(key);
    return response.data;
};

export const useSystemConfigByKeyQuery = (key: string) => {
    return useQuery(['systemConfig', { key }], fetchSystemConfigByKey, {
        enabled: !!key,
    });
};
